(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ulike-home-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-feature-showcase')) {
    customElements.define('ulike-feature-showcase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.ulike-feature-showcase__item')];
        this.videos = [...this.querySelectorAll('[data-deferred-video]')];
        this.visibleVideos = new Set();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.carousel = this.hasAttribute('data-carousel') && this.slides.length > 1;
        this.activeIndex = 0;
        this.prev = this.querySelector('[data-feature-prev]');
        this.next = this.querySelector('[data-feature-next]');
        this.status = this.querySelector('[data-feature-status]');
        if (this.carousel) {
          this.prev.addEventListener('click', () => this.select(this.activeIndex - 1), options);
          this.next.addEventListener('click', () => this.select(this.activeIndex + 1), options);
          this.addEventListener('keydown', (event) => {
            if (event.target !== this.prev && event.target !== this.next) return;
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1);
            this.select(index);
          }, options);
          const stage = this.querySelector('.ulike-feature-showcase__list');
          stage.addEventListener('touchstart', (event) => {
            this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY, time: Date.now() } : null;
          }, { ...options, passive: true });
          stage.addEventListener('touchcancel', () => { this.touch = null; }, options);
          stage.addEventListener('touchend', (event) => {
            const start = this.touch;
            this.touch = null;
            if (!start || !event.changedTouches.length || event.touches.length) return;
            const dx = event.changedTouches[0].clientX - start.x;
            const dy = event.changedTouches[0].clientY - start.y;
            if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.2 || Date.now() - start.time > 800) return;
            this.select(this.activeIndex + (dx < 0 ? 1 : -1));
          }, { ...options, passive: true });
          stage.addEventListener('ulike:drag-switch', (event) => {
            this.select(this.activeIndex + event.detail.direction);
          }, options);
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target.closest('.ulike-feature-showcase__item'));
            if (index >= 0) this.select(index);
          }, options);
          this.setAttribute('data-enhanced', '');
          this.querySelector('.ulike-feature-showcase__navigation').hidden = false;
          this.select(0);
        }
        document.addEventListener('visibilitychange', () => this.updateVideos(), options);
        this.motion.addEventListener('change', () => this.updateVideos(), options);
        navigator.connection?.addEventListener('change', () => this.updateVideos(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) this.visibleVideos.add(target);
              else this.visibleVideos.delete(target);
            });
            this.updateVideos();
          });
          this.videos.forEach((video) => this.observer.observe(video));
        } else {
          this.videos.forEach((video) => { video.controls = true; });
        }
      }

      select(index) {
        this.activeIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', String(i !== this.activeIndex));
          slide.inert = i !== this.activeIndex;
        });
        this.prev.disabled = this.activeIndex === 0;
        this.next.disabled = this.activeIndex === this.slides.length - 1;
        this.status.textContent = `${this.activeIndex + 1} / ${this.slides.length}`;
        if (document.activeElement === this.prev && this.prev.disabled) this.next.focus();
        if (document.activeElement === this.next && this.next.disabled) this.prev.focus();
        this.updateVideos();
      }

      updateVideos() {
        this.videos.forEach((video) => {
          const active = !this.carousel || this.slides[this.activeIndex].contains(video);
          if (!active || !this.visibleVideos.has(video) || document.hidden || this.motion.matches || navigator.connection?.saveData) {
            video.pause();
            return;
          }
          const sources = [...video.querySelectorAll('source[data-src]')];
          sources.forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          if (sources.length) video.load();
          video.play().catch(() => {});
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.videos?.forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
